import { Button as UIButton } from '@faststore/ui'
import { ShoppingCart as ShoppingCartIcon } from 'phosphor-react'
import React from 'react'

import type { ButtonProps } from '@faststore/ui'

import './buy-button.scss'

function BuyButton({ children, ...props }: ButtonProps) {
  return (
    <UIButton className="button" data-store-buy-button {...props}>
      <ShoppingCartIcon size="18" weight="bold" />
      {children}
    </UIButton>
  )
}

export default BuyButton
